import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConfirmHistory, User } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-confirm-dialog',
  templateUrl: './user-confirm-dialog.component.html',
  styleUrls: ['./user-confirm-dialog.component.css']
})
export class UserConfirmDialogComponent implements OnInit {

  constructor(
    private userService: UserService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService, 
    private dialogRef: MatDialogRef<UserConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) { 
    this.user = data.user
    this.status = data.status
    if(this.status == 'ON') {
      this.popupTitle = '회원가입 승인'
      this.buttonTitle = '승인'
    } else if(this.status == 'RR') {
      this.popupTitle = '회원가입 승인요청'
      this.buttonTitle = '요청'
    } else if(this.status == 'RJ' && this.user.status == 'RD') {
      this.popupTitle = '회원가입 반려'
      this.buttonTitle = '반려'
    } else if(this.status == 'RD' && this.user.status == 'RD') {
      this.popupTitle = '재승인요청 사유 확인'
      let confirmHistoryList: ConfirmHistory[] = data.confirmHistoryList
      let lastedRj: ConfirmHistory = confirmHistoryList.find(ch => ch.status == 'RD')
      if(lastedRj) {
        this.comment = lastedRj.comment
      }
    } else if(this.status == 'RJ' && this.user.status == 'RJ') {
      this.popupTitle = '반려사유 확인'
      let confirmHistoryList: ConfirmHistory[] = data.confirmHistoryList
      let lastedRj: ConfirmHistory = confirmHistoryList.find(ch => ch.status == 'RJ')
      if(lastedRj) {
        this.comment = lastedRj.comment
      }
    } else if(this.status == 'changeGrade') {
      this.popupTitle = '회원등급 변경'
      this.buttonTitle = '저장'
      this.userGrade = this.user.userGrade
    } else if(this.status == 'userClass') {
      this.popupTitle = '회원분류 지정'
      this.buttonTitle = '지정'
      this.userClass = this.user.userClass ?? ''
    }
  }

  popupTitle: string
  buttonTitle: string
  status: string
  user: User
  userGrade: string
  userClass: string
  ngOnInit(): void {
  }

  popupClose() {
    this.dialogRef.close();
  }

  comment: string
  proc() {
    if(this.status == 'ON') {
      this.spinner.show()
      this.userService.userConfirm(this.user.userNo, this.user.userGrade).subscribe(res => {
        this.spinner.hide()
        if(res.resultCode != '0000') {
          alert(res.message)
        } else {
          alert("정상적으로 승인 처리 되었습니다.")
        }
        this.popupClose()
      })
    } else if(this.status == 'RJ') { 
      if(!this.comment || this.comment.length == 0) {
        return alert("반려 사유를 입력해주세요")
      }
      if(confirm('반려 처리 하시겠습니까?')) {
        this.spinner.show()
        this.userService.userReject(this.user.userNo, this.comment).subscribe(res => {
          this.spinner.hide()
          if(res.resultCode != '0000') {
            alert(res.message)
          } else {
            alert("정상적으로 반려 처리 되었습니다.")
          }
          this.popupClose()
        })
      }
    } else if(this.status == 'RR') { 
      if(!this.comment || this.comment.length == 0) {
        return alert("승인사유를 입력해주세요")
      }
      this.spinner.show()
      this.userService.userConfirmRequest(this.user.userNo, this.comment).subscribe(res => {
        this.spinner.hide()
        if(res.resultCode != '0000') {
          alert(res.message)
        } else {
          alert("정상적으로 요청 처리 되었습니다.")
        }
        this.popupClose()
      })
    } else if(this.status == 'changeGrade') { 
      if(this.user.userGrade == this.userGrade) {
        return alert("변경된 사항이 없습니다.")
      }
      this.spinner.show()
      this.userService.userGradeUpdate(this.user.userNo, this.userGrade).subscribe(res => {
        this.spinner.hide()
        if(res.resultCode != '0000') {
          alert(res.message)
        } else {
          alert("정상적으로 처리 되었습니다.")
        }
        this.popupClose()
      })
    } else if(this.status == 'userClass') { 
      if(this.userClass == '') {
        return alert("고객 분류를 지정해주세요.")
      }
      if(this.user.userClass == this.userClass) {
        return alert("변경된 사항이 없습니다.")
      }
      this.spinner.show()
      this.userService.userClassUpdate(this.user.userNo, this.userClass).subscribe(res => {
        this.spinner.hide()
        if(res.resultCode != '0000') {
          alert(res.message)
        } else {
          alert("정상적으로 처리 되었습니다.")
        }
        this.popupClose()
      })
    } else {
      alert('준비중입니다.')
    }
  }
}
